import script from "./UploadResume.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadResume.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__